import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { DateTime, ShowExpanded } from '../shared';
import ActionPriority from './ActionPriority';

function statusText(status) {
  switch (status) {
    case 1:
      return 'Niet gestart';
    case 2:
      return 'Wordt uitgevoerd';
    case 3:
      return 'Afgewerkt';
    case 4:
      return 'Uitgesteld';
    case 5:
      return 'Geannuleerd';
    default:
      return status.toString();
  }
}

@observer
class ActionItem extends Component {
  constructor() {
    super();
    this.state = { expanded: false };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState(state => ({ expanded: !state.expanded }));
  }

  render() {
    const { action } = this.props;
    const { expanded } = this.state;
    const comment = action.actDesc;
    const lines = comment.split('\n');

    if (expanded) {
      return (
        <div className="list-group-item">
          <div className="form-group" onClick={this.toggle}>
            <ShowExpanded expanded={expanded} />
            {lines.map((t, i) => <span key={i}>{t}<br /></span>)}
          </div>
          <div className="form-group">
            <label>Gebied:</label>
            <span className="form-control">
              {action.areaMain}/{action.areaSub}
            </span>
          </div>
          <div className="form-group">
            <label>Status:</label>
            <span className="form-control">{statusText(action.actStat)}</span>
          </div>
          <div className="form-group">
            <label>Medewerker:</label>
            <span className="form-control">{action.empNr}</span>
          </div>
          <div className="form-group">
            <label>Prioriteit:</label>
            <span className="form-control">{action.priority}</span>
          </div>
          <div className="form-group">
            <label>From:</label>
            <span className="form-control">
              <DateTime value={action.actStart} />
            </span>
          </div>
          <div className="form-group">
            <label>To:</label>
            <span className="form-control">
              <DateTime value={action.actFinish} />
            </span>
          </div>
          <ActionPriority priority={action.actPrior} status={action.actStat} />
        </div>
      );
    } else {
      return (
        <div className="list-group-item" onClick={this.toggle}>
          <ShowExpanded expanded={expanded} />
          {lines[0]}
        </div>
      );
    }
  }
}

export default ActionItem;



// WEBPACK FOOTER //
// ./src/actions/ActionItem.js